import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import type { RootState, AppDispatch } from '../store'
import { initiateCheckout } from '../store/slices/subscriptionSlice'
import clsx from 'clsx'

export default function UsageBanner() {
  const dispatch = useDispatch<AppDispatch>()
  const dailyUsage = useSelector((state: RootState) => state.evaluation.dailyUsage)
  const dailyLimit = useSelector((state: RootState) => state.evaluation.dailyLimit)
  const checkoutLoading = useSelector((state: RootState) => state.subscription.loading)

  const remaining = Math.max(0, dailyLimit - dailyUsage)
  const atLimit = remaining === 0
  const progressPercent = dailyLimit > 0 ? Math.min((dailyUsage / dailyLimit) * 100, 100) : 0

  // Don't show banner for unlimited (pro) users
  if (dailyLimit <= 0) return null

  return (
    <div className={clsx(
      'glass-card px-4 py-3 flex flex-col sm:flex-row items-start sm:items-center gap-3',
      atLimit && 'border-amber-500/30'
    )}>
      <div className="flex-1 min-w-0">
        {atLimit ? (
          <p className="text-sm text-amber-600 dark:text-amber-300">
            Daily limit reached — Upgrade to Pro for unlimited evaluations
          </p>
        ) : (
          <p className="text-sm text-gray-600 dark:text-gray-300">
            <span className="font-medium text-gray-900 dark:text-white">{remaining}</span> of{' '}
            <span className="font-medium text-gray-900 dark:text-white">{dailyLimit}</span> free evaluations remaining today
          </p>
        )}
        <div className="mt-2 w-full max-w-xs h-1.5 bg-gray-200 dark:bg-gray-800 rounded-full overflow-hidden">
          <div
            className={clsx(
              'h-full rounded-full transition-all duration-500',
              atLimit ? 'bg-amber-500' : 'bg-emerald-500'
            )}
            style={{ width: `${progressPercent}%` }}
          />
        </div>
      </div>
      <button
        className="btn-primary text-xs py-2 px-4 shrink-0"
        onClick={() => dispatch(initiateCheckout())}
        disabled={checkoutLoading}
      >
        {checkoutLoading ? 'Redirecting...' : 'Upgrade to Pro'}
      </button>
    </div>
  )
}
